module.exports = {
  XmlEntities: require(7),
  Html4Entities: require(5),
  Html5Entities: require(6),
  AllHtmlEntities: require(6)
};
